export class ClubFittingDataPayload {
    constructor(
        public header = new Header(),
        public appContext = new AppContext(),
        public fittingContext = new FittingContext(),
        public clubConfigurationTests = new Array<ClubConfigurationTest>(),
        public fittingRecommendations = new Array<ClubRecommendation>()
    ) { }
}

export class Header {
    constructor(
        public id = "",
        public startTime = "",
        public endTime = "",
        public appVersion = "",
    ) { }
}

export class AppContext {
    constructor(
        public settings = new Array<Question>()
    ) { }

}

export class FittingContext {
    constructor(
        public fitter = new Person(),
        public golfer = new Person(),
        public survey = new Array<Question>(),
        public clubShotPreferences = new Array<ClubShotPreference>()
    ) { }
}

export class Person {
    constructor(
        public firstName = "",
        public lastName = "",
        public email = "",
        public role = "",
        public gender = "",
        public handicap = "",
        public age = ""
    ) { }
}


export class ClubShotPreference {
    constructor(
        public club = new Club(),
        public shotTypes = new Array<ShotType>()
    ) { }
}

export class ShotType {
    constructor(
        public presentation = "",
        public swingTechnique = "",
        public shotPreference = ""
    ) { }
}
export class Club {
    constructor(
        public lineNumber = 0,
        public head = new Head(),
        public shaft = new Shaft(),
        public grip = new Grip()
    ) { }
}

export class Head {
    constructor(
        public category = "",
        public loft = "",
        public bounce = "",
        public grind = ""
    ) { }
}

export class Shaft {
    constructor(
        public brand = "",
        public model = "",
        public flex = "",
        public length = ""
    ) { }
}

export class Grip {
    constructor(
        public brand = "",
        public model = "",
        public size = ""
    ) { }
}

export class Question {
    constructor(
        public name = "",
        public value = ""
    ) { }
}

export class Reason {
    constructor(
        public name = "",
        public value = ""
    ) {}
}

export class ShotDetail {
    constructor(
        public loft = "",
        public shotData = ""
    ) { }
}


export class ClubConfigurationTest {
    constructor(
        public club = new Club(),
        public ball = new Ball(),
        public shots = new Array<Shot>(),
        public person = new Person()
    ) {}
}

export class ClubConfigurationTestOLD {
    constructor(
        public startTime = new Date(),
        public endTime = new Date(),
        public device = new Device(),
        public club = new Club(),
        public ball = new Ball(),
        public person = new Person(),
        public shot = new ShotAnalysis(),
        public isDeleted = "",
        public shotType = new ShotType(),
        public attackAngle = "",
        public shaftLean = "",
        public ballSpeed = "",
        public launchDirection = "",
        public grindRecommendations = new Array<ClubRecommendation>(),
        public devicePayload = new DevicePayload()
    ) { }
}

export class ShotAnalysis {
    constructor(
        public attackAngle = "",
        public shaftLean = "",
        public ballSpeed = "",
        public launchDirection = "",
    ) { }
}

export class Shot {
    constructor(
        public lineNumber = 0,
        public startTime = "",
        public endTime = "",
        public device = new Device(),
        public club = new Club(),
        public ball = new Ball(),
        public isDeleted = "",
        public shotType = new ShotType(),
        public shotAnalysis = new ShotAnalysis(),
        public devicePayload = new DevicePayload(),
        public shotRecommendations = new Array<ClubRecommendation>()
    ) {}
}

export class Ball {
    constructor(
        public brand = "",
        public model = "",
        public version = ""
    ) { }
}

export class Device {
    constructor(
        public brand = "",
        public model = "",
        public version = ""
    ) { }
}

export class DevicePayload {
    constructor(
        public id = "",
        public type = "",
        public data = "",
    ) { }
}


export class ClubRecommendation {
    constructor (
        public club = new Club(),
        public selected = "",
        public rankPercent = "",
        public reasons = new Array<Reason>()
    ) {}
}